import { AxiosResponse } from 'axios'
import { IApiSuccessResponse } from 'interfaces/api-success-response'
import { IEstablishmentRequest } from 'interfaces/establishment'
import { IRefundOrder, ISubscriptionCreateResponse } from 'interfaces/payment'
import { IStripePayment, IStripePaymentResponse } from 'interfaces/stripe'
import { IPaymentOrder, ITabPaymentItem } from 'interfaces/tab'
import { ITabsPaymentRequest } from 'interfaces/tabs'
import httpClient from './base-service'

const endPointBaseURL = `/Payment`

const addTabPayment = async (
  requestBody: ITabsPaymentRequest
): Promise<AxiosResponse<IApiSuccessResponse<ITabPaymentItem>>> =>
  httpClient.post<IApiSuccessResponse<ITabPaymentItem>>(
    `${endPointBaseURL}/add-tab-payment`,
    requestBody,
    {
      hideLoader: true,
    }
  )

const createPaymentIntent = async (
  requestBody: IStripePayment
): Promise<AxiosResponse<IApiSuccessResponse<IStripePaymentResponse>>> =>
  httpClient.post<IApiSuccessResponse<IStripePaymentResponse>>(
    `${endPointBaseURL}/create-payment-intent-qr-payment`,
    requestBody,
    {
      hideLoader: false,
      suppressErrorToast: true,
    }
  )

const refundOrder = async (
  requestBody: IRefundOrder[]
): Promise<AxiosResponse<IApiSuccessResponse<string>>> =>
  httpClient.post<IApiSuccessResponse<string>>(
    `${endPointBaseURL}/add-refund`,
    requestBody,
    {
      hideLoader: true,
    }
  )

const paymentOrder: IPaymentOrder[] = null

const createSubscription = async (
  requestBody: IEstablishmentRequest
): Promise<AxiosResponse<IApiSuccessResponse<ISubscriptionCreateResponse>>> =>
  httpClient.post<IApiSuccessResponse<ISubscriptionCreateResponse>>(
    `${endPointBaseURL}/create-subscription`,
    requestBody,
    {
      hideLoader: false,
    }
  )

const createSubscriptionSetupIntent = async (requestBody: {
  establishmentId: string
}): Promise<
  AxiosResponse<
    IApiSuccessResponse<{
      clientSecret: string
      customerId: string
      currency: string
      isPaid?: boolean // Optional: true when all subscriptions are already paid
      message?: string // Optional: message when isPaid is true
    }>
  >
> =>
  httpClient.post<
    IApiSuccessResponse<{
      clientSecret: string
      customerId: string
      currency: string
      isPaid?: boolean
      message?: string
    }>
  >(`${endPointBaseURL}/create-subscription-setup-intent`, requestBody)

const confirmPaymentStatus = async (
  paymentIntentId: string
): Promise<AxiosResponse<IApiSuccessResponse<boolean>>> =>
  httpClient.get<IApiSuccessResponse<boolean>>(
    `${endPointBaseURL}/confirm-payment-status/${paymentIntentId}`,
    {
      hideLoader: false,
    }
  )

const getPaymentMethodDetails = async (requestBody: {
  posTableId: number
  establishmentId: number
}): Promise<AxiosResponse<IApiSuccessResponse<any>>> =>
  httpClient.post<IApiSuccessResponse<any>>(
    `${endPointBaseURL}/get-payment-method-details`,
    requestBody,
    {
      hideLoader: false,
      suppressErrorToast: true,
    }
  )

// Guest checkout: step 1 - create/update payment intent
const createCheckoutIntent = async (
  requestBody: any
): Promise<AxiosResponse<IApiSuccessResponse<any>>> =>
  httpClient.post<IApiSuccessResponse<any>>(
    `/order/create-intent`,
    requestBody,
    {
      hideLoader: false,
      suppressErrorToast: true,
    }
  )

// Guest checkout: step 2 - submit order using existing payment intent
const submitCheckoutOrder = async (
  requestBody: any
): Promise<AxiosResponse<IApiSuccessResponse<any>>> =>
  httpClient.post<IApiSuccessResponse<any>>(
    `/order/submit-order`,
    requestBody,
    {
      hideLoader: false,
      suppressErrorToast: true,
    }
  )

export default {
  addTabPayment,
  createPaymentIntent,
  createCheckoutIntent,
  submitCheckoutOrder,
  paymentOrder,
  refundOrder,
  createSubscription,
  createSubscriptionSetupIntent,
  confirmPaymentStatus,
  getPaymentMethodDetails,
}
